const isWebView = () =>
  window &&
  window.navigator &&
  window.navigator.userAgent &&
  (window.navigator.userAgent.includes('medflexMobileWebView') ||
    window.location.href.includes('/mobile/'));

export default isWebView;
